import styled, { css } from 'styled-components';

import { SPACING, Spacing } from '@optimus-web/local-tokens';

interface PaddingProps {
    vertical?: Spacing;
    horizontal?: Spacing;
}

const Padding = styled.div`
    ${({ vertical, horizontal }: PaddingProps) => {
        const verticalPadding = SPACING[vertical ?? 0];
        const horizontalPadding = SPACING[horizontal ?? 0];

        return css`
            padding: ${verticalPadding}px ${horizontalPadding}px;
        `;
    }}
`;

export default Padding;
